import type { PermissionLevel } from "../hooks/usePermissionLevel";

export interface NavItem {
  icon: string;
  label: string;
  path: string;
  minLevel: PermissionLevel;
}

/**
 * The destinations listed in the account/avatar menu. Library is
 * deliberately absent: the header wordmark ("Maru Labs") is itself the
 * Library link, so listing it again here would be a duplicate affordance.
 * Order here is the order items appear in the avatar menu; it is declaration
 * order rather than privilege order, so a manager and an admin see the same
 * items in the same places and only the admin sees more of them.
 */
export const NAV_ITEMS: NavItem[] = [
  { icon: "group", label: "Member management", path: "team", minLevel: "manager" },
  { icon: "admin_panel_settings", label: "Admin", path: "admin", minLevel: "admin" },
  { icon: "rule", label: "Rubrics & Frameworks", path: "rubrics", minLevel: "manager" },
];

const RANK: Record<PermissionLevel, number> = { member: 0, manager: 1, admin: 2 };

/**
 * Frontend gating is UX convenience only — the security boundary is the
 * server's MinLevelGuard. This hides destinations a user cannot use; it does
 * not protect them.
 */
export function navItemsFor(level: PermissionLevel): NavItem[] {
  return NAV_ITEMS.filter((item) => RANK[level] >= RANK[item.minLevel]);
}
